<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${coverWidth} ${coverHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect id="Frame" x="0" y="0" :width="coverWidth" :height="coverHeight" />
      <g ref="main" style="isolation: isolate">
        <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
          <picture>
            <source :srcset="`${publicPath}scenes/cliff-dwellings/CliffDwellings1-480w.jpg`" media="(max-width: 480px)">
            <source :srcset="`${publicPath}scenes/cliff-dwellings/CliffDwellings1-768w.jpg`" media="(max-width: 768px)">
            <source :srcset="`${publicPath}scenes/cliff-dwellings/CliffDwellings1-1280w.jpg`" media="(max-width: 1280px)">
            <source :srcset="`${publicPath}scenes/cliff-dwellings/CliffDwellings1-1920w.jpg`" media="(max-width: 1920px)">
            <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/cliff-dwellings/CliffDwellings1.jpg`" />
          </picture>
        </foreignObject>
        <g class="smoke">
          <image opacity="0.5" width="561" height="650" x="746" y="1400" :xlink:href="`${publicPath}scenes/cliff-dwellings/CliffDwellings2.png`"/>
          <image opacity="0.5" width="564" height="650" x="746" y="1400" :xlink:href="`${publicPath}scenes/cliff-dwellings/CliffDwellings3.png`"/>
          <image opacity="0.5" width="650" height="689" x="691" y="1328" :xlink:href="`${publicPath}scenes/cliff-dwellings/CliffDwellings4.png`"/>
        </g>
      </g>
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.33"
      :tx=".96" :ty=".78">
      He was good with his hands. That’s how he made an extra buck as a
      blacksmith— just another one of the many hats Max wore. He was recruited
      by the Civilian Conservation Corps to work on the alcove trails that
      went down to Navajo National Monument. He knew all the old trails.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/cliff-dwellings/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    coverWidth: 4175,
    coverHeight: 3006,
    showContent: false,
  }),
  extends: Template,
  mounted() {
    const main = this.$refs["main"]
    const d = this.$refs["dialogue"].$el
    TweenLite.set(main, {opacity: 0})
    TweenLite.set(d, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 1, {opacity: 1}), 0.5)
    this.tl.add(TweenLite.to(d, 1, {opacity: 1}))
  },
  methods: {
    enter() {this.tl.play()}
  },
  props: ["slide"]
}
</script>

<style lang="scss" scoped>
.smoke {
  image {
    animation: smoke 1s infinite;
    animation-timing-function: steps(0, end);
    &:nth-of-type(1) { animation-delay: 0s; }
    &:nth-of-type(2) { animation-delay: -.33s; }
    &:nth-of-type(3) { animation-delay: -.66s; }
  }
}

@keyframes smoke {
  0% { opacity: 0.4 }
  50% { opacity: 0 }
  100% { opacity: 0.4 }
}
</style>
